/**
 * src/components/debug/DebugPanelProviderBridge.jsx — Phase Z
 *
 * Rendered INSIDE AppDataProvider. Reads context arrays and forwards them
 * to DebugPanel as the `store` prop. AppShell cannot call useAppDataContext()
 * directly (it IS the component that renders the provider), so this bridge
 * component handles the context read for it.
 */

import { useAppDataContext } from '../../lib/AppDataContext.jsx';
import DebugPanel from './DebugPanel.jsx';

export default function DebugPanelProviderBridge(props) {
  const {
    projects = [],
    bundles = [],
    tasks = [],
    deals = [],
    people = [],
    vesselContacts = [],
    purchaseOrders = [],
    suppliers = [],
    timeLogs = [],
  } = useAppDataContext();
  return (
    <DebugPanel
      {...props}
      store={{
        projects, bundles, tasks, deals,
        people, vesselContacts, purchaseOrders, suppliers, timeLogs,
      }}
    />
  );
}
